import { useLocale } from 'hooks/useLocale/useLocale';
import { AppMessages } from 'i18n/messages';
import { Table } from 'ui/table/Table';
import { useSelectedUser } from 'hooks/useSelectedUser/useSelectedUser';

import { UsersTableHeader } from './usersTableHeader/UsersTableHeader';
import { UsersTableRow } from './usersTableRow/UsersTableRow';
import { UsersListProps } from './UsersList.types';

const TABLE_MIN_WIDTH = 950;

export const UsersList = ({
  users,
  isLoadingUsers,
  page,
  setPage,
  usersCount,
  rowsPerPage,
  setRowsPerPage,
}: UsersListProps) => {
  const { formatMessage } = useLocale();

  const { selectedUser, setSelectedUser } = useSelectedUser();

  return (
    <Table
      isLoading={isLoadingUsers}
      pagination={{
        page,
        setPage,
        count: usersCount,
        rowsPerPage,
        setRowsPerPage,
      }}
      gridTemplateColumns="1fr 1.5fr 1fr 0.5fr"
      data={users}
      nothingToShowText={formatMessage({ id: AppMessages['users.nothingToShow'] })}
      renderHeader={() => <UsersTableHeader />}
      renderRow={(user) => <UsersTableRow user={user} />}
      onClickRow={(user) => setSelectedUser(selectedUser?.id === user.id ? undefined : user)}
      activeRowId={selectedUser?.id}
      tableMinWidth={TABLE_MIN_WIDTH}
    />
  );
};
